const procesHoverModule = () => {

    const procesContainers = document.querySelectorAll('[data-proces-container]');

    //get all proces items from proces container and group them
    for (let p = 0; p < procesContainers.length; p++) {
        const procesItems = procesContainers[p].querySelectorAll('[data-proces-item]');
    
        for (let i = 0; i < procesItems.length; i++) {
            //add hover event to all items
            procesItems[i].addEventListener('mouseenter', () => {
                //add active class to all others left side element (from event element)
                for (let a = i - 1; a >= 0; a--) {
                    procesItems[a].classList.add('active');
                }
            });

            //delete all active lement if mouse leave the element
            procesItems[i].addEventListener('mouseleave', () => {
                //remove active class from all others left side element (from event element)
                for (let a = i - 1; a >= 0; a--) {
                    procesItems[a].classList.remove('active');
                }
            });
        }
    }

}

export {procesHoverModule};